import { post, webApi } from '../utils/http';

export const services = {
  submitContact: (email, message) =>
    post(webApi + 'api/support/contact', { email, message }),
};
